import { render, staticRenderFns } from "./DetailsBar.vue?vue&type=template&id=3577f379&"
import script from "./DetailsBar.vue?vue&type=script&lang=js&"
export * from "./DetailsBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports